import { render, staticRenderFns } from "./BaseCheckBox.vue?vue&type=template&id=39988f2a"
import script from "./BaseCheckBox.vue?vue&type=script&lang=js"
export * from "./BaseCheckBox.vue?vue&type=script&lang=js"
import style0 from "./BaseCheckBox.vue?vue&type=style&index=0&id=39988f2a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports